import { render, staticRenderFns } from "./SidePanel.vue?vue&type=template&id=cdcd9962&scoped=true"
import script from "./SidePanel.vue?vue&type=script&lang=ts"
export * from "./SidePanel.vue?vue&type=script&lang=ts"
import style0 from "./SidePanel.vue?vue&type=style&index=0&id=cdcd9962&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdcd9962",
  null
  
)

export default component.exports